import React,{useEffect} from "react";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import UserViewForm from "./UserViewForm";
import { useTranslation } from "react-i18next";
import { GridStack } from "gridstack";
import DMSHeader from "../../DMSHeader/DMSHeader";

const UserViewmain = () => {

    const { t } = useTranslation();


    useEffect(() => {

        GridStack.init();
    }, []);
    const layoutData = [
        {
            x: 0,
            y: 0,
            width: 12,
            height: 1,
            id: 0,
            component: (
                <DMSHeader
                    title={
                        t("View Task Details")
                    }
                    fileName=""
                    showmenu={true}
                    showdownload={false}
                    showIconsForback={true}
                    showImportDropDownLabel={false}

                />
            ),
            haveOverflowVisible: true,
        },
        {
            x: 0,
            y: 1,
            width: 12,
            height: 12,
            id: 1,
            component: <UserViewForm />,
        },
    ];
    return (
        <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
            <GridItem layoutData={layoutData} />
        </div>
    );
}
export default UserViewmain